"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.absenceInputSchema = exports.absenceSchema = exports.allocationInputSchema = exports.allocationSchema = exports.allocationStatusSchema = exports.ALLOCATION_STATUSES = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
exports.ALLOCATION_STATUSES = ['angefragt', 'freigegeben', 'abgelehnt', 'verschoben'];
exports.allocationStatusSchema = zod_1.z.enum(exports.ALLOCATION_STATUSES);
/** Year is explicit: calendar week 1 without its year is ambiguous. */
const allocationBaseSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    employeeId: common_js_1.idSchema.nullable(),
    projectId: common_js_1.idSchema,
    workPackageId: common_js_1.idSchema.nullable(),
    fachgruppeId: common_js_1.idSchema,
    isoYear: common_js_1.isoYearSchema,
    isoWeek: common_js_1.isoWeekSchema,
    hours: common_js_1.hoursSchema,
    status: exports.allocationStatusSchema,
    requestedById: common_js_1.idSchema,
    decidedById: common_js_1.idSchema.nullable(),
    decidedAt: zod_1.z.iso.datetime({ offset: true }).nullable(),
    note: zod_1.z.string().optional(),
    version: zod_1.z.number().int().nonnegative(),
});
exports.allocationSchema = allocationBaseSchema.refine(common_js_1.isValidIsoWeek, {
    message: 'ISO week does not exist in this year',
    path: ['isoWeek'],
});
exports.allocationInputSchema = allocationBaseSchema
    .pick({
    employeeId: true,
    projectId: true,
    workPackageId: true,
    fachgruppeId: true,
    isoYear: true,
    isoWeek: true,
    hours: true,
    note: true,
})
    .refine(common_js_1.isValidIsoWeek, {
    message: 'ISO week does not exist in this year',
    path: ['isoWeek'],
});
exports.absenceSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    employeeId: common_js_1.idSchema,
    date: common_js_1.dateSchema,
    reason: common_js_1.textSchema,
    hours: common_js_1.hoursSchema,
});
exports.absenceInputSchema = exports.absenceSchema.pick({
    employeeId: true,
    date: true,
    reason: true,
    hours: true,
});
//# sourceMappingURL=planning.js.map